import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from "@angular/router";
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {

  public isShowPreloader: boolean = true;

  public routerSubscribe: Subscription;

  public disableForYtVideosMweb: boolean = false;

  constructor(
    private _router: Router,
    private _helper: HelperService,
    private deviceService: DeviceDetectorService,
  ) {
    
    this._router.events.subscribe((e : any) => {
      this.checkRouteChange(e);
      const isMobile = this.deviceService.isMobile();
      //@ts-ignore
      this.disableForYtVideosMweb = (this._router.url == '/selfLearn-V2/ytVideos' && isMobile == true) ? true : false;
      if(this.disableForYtVideosMweb){
        document.getElementById('layout').style.top = '-75px';
        document.getElementById('layout').style.position = 'relative';
        document.getElementById('layout').style.paddingTop = '70px';
      }
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if(this.routerSubscribe) {
      this.routerSubscribe.unsubscribe();
    }
  }

  checkRouteChange( routerEvent:RouterEvent){
    // if route change started
    if(routerEvent instanceof NavigationStart){
      document.body.classList.add('no-scroll')
      const _referrer = this._helper.removeQueryParam(localStorage.getItem('crntLink'));
      const _crntUrl = this._helper.removeQueryParam(this._router.url);
      if(_referrer !== _crntUrl) {
        this.isShowPreloader = true;
      }
    }
    // if route change ended
    if(routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ){
      setTimeout(() => {
        // setting referer url
        localStorage.setItem('crntLink', this._router.url)

        document.body.classList.remove('no-scroll');
        this.isShowPreloader = false;
      }, 500);
    }
  }
}
